<script>
import focusTrap from 'focus-trap';

export default {
  abstract: true,

  props: {
    initialFocus: {
      type: String,
    },
    allowOutsideClick: {
      type: Boolean,
      default: false,
    },
    clickOutsideDeactivates: {
      type: Boolean,
      default: true,
    },
    isEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      trap: undefined,
    };
  },

  watch: {
    isEnabled(isEnabled) {
      isEnabled && this.activate();
      !isEnabled && this.deactivate();
    },
  },

  mounted() {
    this.init();
    this.isEnabled && this.activate();
  },

  updated() {
    if (!this.isEnabled) return;
    this.deactivate();
    this.$nextTick(() => {
      this.activate();
    });
  },

  beforeUnmount() {
    this.deactivate();
  },

  methods: {
    init() {
      if (this.trap) return;
      this.trap = focusTrap(this.$el, {
        initialFocus: () => {
          const element = this.$el.querySelector(this.initialFocus);
          return element || undefined;
        },
        allowOutsideClick: () => {
          return this.allowOutsideClick;
        },
        clickOutsideDeactivates: () => {
          return this.clickOutsideDeactivates;
        },
      });
    },
    activate() {
      if (!this.trap) this.init();
      this.trap.activate();
    },
    deactivate() {
      if (!this.trap) return;
      this.trap.deactivate();
    },
  },

  render() {
    // Without using a wrapper component, we can only render one child component.
    try {
      return this.$slots.default[0];
    } catch (e) {
      throw new Error(
        'Intersect can only render one, and exactly one child component.'
      );
    }

    return null;
  },
};
</script>
